<template>
  <div>
    <div
      class="side-frame-success d-flex align-items-center mt-1 mb-4"
      style="font-size: 14px; color: #6c6c6c"
    >
      <span class="mr-1">No:</span>
      <span>
        {{ baseInfo.devTrackingQuotationNo || '--' }}
      </span>
      <el-divider direction="vertical" />
      <span class="mr-1">Version No:</span>
      <span>
        {{ baseInfo.lastVersionNo || '--' }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span class="mr-1">Create:</span>
      <span>
        {{ baseInfo.createByName || '--' }} at
        {{ baseInfo.createDate || '--' }}
      </span>
    </div>

    <h6 style="color: #101010" class="mb-3">
      {{ $l('form_header_goods') || '产品报价' }}
    </h6>
    <ProductCard
      :devTrackingQuotationNo="devTrackingQuotationNo"
      :tskInfoNo="tskInfoNo"
      class="mb-4"
    />

    <h6 style="color: #101010" class="mb-3">
      {{ $l('form_header_quotation') || '报价信息' }}
    </h6>
    <BaseForm
      ref="baseForm"
      :devTrackingQuotationNo="devTrackingQuotationNo"
      :tskInfoNo="tskInfoNo"
      :disabled="disabled"
      @loaded="baseLoaded"
      class="mb-4"
    />
    <SampleSpec
      ref="sampleSpec"
      class="mt-3"
      :disabled="disabled"
      :devTrackingQuotationNo="devTrackingQuotationNo"
    />
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import ProductCard from '../product-card'
import BaseForm from '../base-form'
import SampleSpec from '../sample-spec'
export default {
  name: 'customerManage-selectionQuotation-detail',
  components: { ProductCard, BaseForm, SampleSpec },
  mixins: [EditLoading],
  props: {
    billNo: { type: String, default: '' },
    tskInfoNo: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { baseInfo: {} }
  },
  computed: {
    devTrackingQuotationNo() {
      return this.billNo
    },
  },
  methods: {
    reload() {
      this.$refs.baseForm.reload()
      this.$refs.sampleSpec.getData()
    },
    baseLoaded(data) {
      this.baseInfo = data

      const { quotationCode } = data
      const disabled = !!quotationCode
      this.$emit('update:disabled', disabled)
    },
    async validate() {
      const baseForm = await this.$refs.baseForm.validate()
      const sampleSpec = await this.$refs.sampleSpec.validate()
      return baseForm && sampleSpec
    },
    async save() {
      if (!(await this.validate())) return

      const form = await this.$refs.baseForm.getFormData()
      const listSpec = await this.$refs.sampleSpec.getTableData()
      const params = { ...form, listSpec }

      if (this.loadingOpen()) return
      const res = await this.saveApi(params)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200 || !body) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      return body
    },
    saveApi(params) {
      return this.tskInfoNo
        ? this.$api
            .customerDevTrackingQuotationTaskAddApi({
              ...params,
              tskInfoNo: this.tskInfoNo,
            })
            .catch(() => null)
        : this.$api
            .customerDevTrackingQuotationSaveApi(params)
            .catch(() => null)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 2px 5px;
  border-left: 3px solid $color-success;
}
</style>
